import BaseModal from "../common/HPBaseModal";
import { WarningIcon } from "@assets/images";
import { ModalProps } from "@_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface DuplicateSurveysModalProps extends ModalProps {
  duplicateSurveyNames: string[];
  action: () => void;
}

const DuplicateSurveysModal: React.FC<DuplicateSurveysModalProps> = ({
  action,
  duplicateSurveyNames,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);
  return (
    <BaseModal
      title="The following surveys are already included in datasets."
      onConfirm={action}
      onCancel={closeTopModal}
      confirmButtonText="Add The Rest of Surveys"
      cancelButtonText="Cancel"
      headerIcon={<WarningIcon />}
    >
      <div className="flex flex-col gap-2">
        {duplicateSurveyNames.map((name, index) => (
          <p key={index}>{name}</p>
        ))}
      </div>
    </BaseModal>
  );
};
export default DuplicateSurveysModal;
